function helperNumberOffsetPoint (str, offsetIndex) {
  return str.substring(0, offsetIndex) + '.' + str.substring(offsetIndex, str.length)
}

module.exports = helperNumberOffsetPoint



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/helperNumberOffsetPoint.js
// module id = 310
// module chunks = 98